import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=00ebae10&scoped=true&"
import script from "./benefits.vue?vue&type=script&lang=js&"
export * from "./benefits.vue?vue&type=script&lang=js&"
import style0 from "./benefits.vue?vue&type=style&index=0&id=00ebae10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ebae10",
  null
  
)

export default component.exports